import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.994 14.5c0-5.247 4.241-9.5 9.473-9.5 5.231 0 9.473 4.253 9.473 9.5S19.698 24 14.467 24s-9.473-4.253-9.473-9.5M14.467 3C8.134 3 3 8.149 3 14.5S8.134 26 14.467 26c2.827 0 5.414-1.026 7.413-2.726l5.418 5.433c.39.39 1.02.39 1.41 0s.39-1.024 0-1.414l-5.424-5.44a11.47 11.47 0 0 0 2.65-7.353C25.934 8.149 20.8 3 14.467 3"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconMagnifyingGlass = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconMagnifyingGlass);
export default Memo;
